import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.873 1.529a1.267 1.267 0 1 1-2.534 0 1.267 1.267 0 0 1 2.534 0ZM16.61 1.529c0-.128.012-.253.036-.373H6.504a1.943 1.943 0 0 1 .014.667h10.114a1.948 1.948 0 0 1-.022-.294ZM3.852 3.31c.185.078.385.129.595.146l.054.003-1.837 10.166a1.926 1.926 0 0 0-.478-.09l-.114-.002h-.069L3.852 3.31ZM18.401 3.457a1.924 1.924 0 0 1-.538-.118l-1.844 10.193.104.004c.194.011.38.05.553.114l1.842-10.188-.117-.005ZM14.076 15.466c0-.1.008-.198.022-.293H3.984a1.949 1.949 0 0 1-.014.666h10.142a1.943 1.943 0 0 1-.036-.373ZM3.34 15.466a1.267 1.267 0 1 1-2.535 0 1.267 1.267 0 0 1 2.534 0ZM16.01 16.733a1.267 1.267 0 1 0 0-2.534 1.267 1.267 0 0 0 0 2.534ZM18.544 2.796a1.267 1.267 0 1 0 0-2.534 1.267 1.267 0 0 0 0 2.534Z",
  fill: "#fff"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }